import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../../../../../lib/supabase'
import { reportUnexpectedError } from '../../../../../lib/reportError'
import { DeviceNameConflictError, isNameConflict } from '../deviceErrors'

interface UpdateDeviceInput {
  id: string
  name: string
  branchId: string
  status: 'active' | 'inactive' | 'pending'
}

async function updateDevice(input: UpdateDeviceInput): Promise<void> {
  const { error } = await supabase
    .from('devices')
    .update({ name: input.name, branch_id: input.branchId, status: input.status })
    .eq('id', input.id)
  if (error) {
    if (isNameConflict(error)) throw new DeviceNameConflictError()
    reportUnexpectedError(error)
    throw error
  }
}

export function useUpdateDevice() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: updateDevice,
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['devices'] }),
  })
}
